import api from './api';
import {
  CalculateShippingRequest,
  CalculateShippingResponse,
  TrackingInfo,
} from '../types/api';

/**
 * Serviço de Frete e Entrega
 */
const shippingService = {
  /**
   * Calcula opções de frete
   */
  async calculate(data: CalculateShippingRequest): Promise<CalculateShippingResponse> {
    const response = await api.post<{
      success: boolean;
      data: CalculateShippingResponse;
    }>('/shipping/calculate', data);
    return response.data.data;
  },

  /**
   * Rastreia entrega
   */
  async track(trackingCode: string): Promise<{ tracking: TrackingInfo }> {
    const response = await api.get<{ tracking: TrackingInfo }>(
      `/shipping/track/${trackingCode}`
    );
    return response.data;
  },
};

export default shippingService;

